import { Injectable } from '@angular/core';
import * as Sentry from '@sentry/browser';
import { throwError } from 'rxjs';
import { AuthService } from 'src/app/lib/auth.service';
import { AgreementStatuses } from 'src/app/models/agreement-statuses/agreement-statuses';
import { AgreementStatusesRepository } from 'src/app/models/agreement-statuses/agreement-statuses-repository';
import { PrivacyPolicyVersion } from 'src/app/models/privacy-policy/privacy-policy-version';
import { TermsOfServiceVersion } from 'src/app/models/terms-of-service/terms-of-service-version';
import { storeAgreementStatuses } from 'src/app/pages/shared/agreement-statuses/agreement-statuses.actions';
import { Dispatcher } from 'src/app/pages/shared/dispatcher';

@Injectable()
export class AgreementStatusesCommands {
  constructor(
    private authService: AuthService,
    private dispatcher: Dispatcher,
    private agreementStatusesRepository: AgreementStatusesRepository,
  ) {}

  async setAgreementStatuses(
    privacyPolicyVersion: PrivacyPolicyVersion,
    termsOfServiceVersion: TermsOfServiceVersion,
  ) {
    const currentUser = this.authService.getCurrentUser();
    if (currentUser === null) {
      return;
    }
    const agreementStatuses = new AgreementStatuses(
      privacyPolicyVersion.valueOf(),
      termsOfServiceVersion.valueOf(),
    );
    try {
      await this.agreementStatusesRepository.set(
        currentUser.uid,
        agreementStatuses,
      );
      this.dispatcher.dispatch(storeAgreementStatuses(agreementStatuses));
    } catch (e) {
      Sentry.captureException(e);
    }
  }
}
